import { WebAppTheme } from "../types/web";

export function isObject(
  value: unknown,
  allowArray = false
): value is Record<string, unknown> {
  return typeof value === "object" && (allowArray || !Array.isArray(value));
}

function iterate(
  value: unknown,
  path: string[] = [],
  vars: Set<[string, string]> = new Set()
): [string, string][] {
  if (isObject(value, true)) {
    if (Array.isArray(value)) {
      value.forEach((varValue, i) => {
        if (typeof varValue === "string") {
          const varName = `${Array.from(path).join("-")}-${i}`;
          vars.add([varName, varValue]);
        }
      });
    } else {
      Object.entries(value).forEach(([key, val]) => {
        path.push(key);
        iterate(val, path, vars);
      });
    }
  } else if (typeof value === "string") {
    const varName = Array.from(path).join("-");
    vars.add([varName, value]);
  } else {
    console.warn(`Unhandled JSON value type ${typeof value}`);
  }

  path.pop();

  return Array.from(vars);
}

export default function createCSSVars(theme: WebAppTheme) {
  const vars = iterate({ colors: theme });

  const acc: { [key: string]: string } = {}; // Explicitly define the type of 'acc' as an object

  return vars.reduce((acc, [name, value]) => {
    acc[`--${name}`] = value;
    return acc;
  }, acc);
}
